// @flow

import React from 'react';
import CheckboxBucket from './checkboxBucket';
import { sortBucketsEntries } from '../helpers';
import { getEntries } from '../../../helpers';

type Props = {
  buckets: { [string]: number },
  name: string,
};

const CheckboxesFacet = ({
  buckets,
  name,
}: Props) => (
  <div>
    {sortBucketsEntries(getEntries(buckets)).map(([bucket, count]) => (
      <CheckboxBucket
        label={name}
        key={bucket}
        bucket={bucket}
        count={count}
      />
    ))}
  </div>
);

export default CheckboxesFacet;
